import angular from 'angular';

module.exports = angular.module('common.values.inspector-crews', [])
  .value('inspectorCrews', [
    { name: 'General', crew: 'inspectors', inspectorRole: 'inspector' },
    { name: 'Electrical', crew: 'inspector_electrical', inspectorRole: 'electrical' },
    { name: 'Estimator', crew: 'estimator', inspectorRole: 'estimator' },
    { name: 'Foundation', crew: 'inspector_foundation', inspectorRole: 'foundation' },
    { name: 'HVAC', crew: 'inspector_hvac', inspectorRole: 'hvac' },
    { name: 'Land Surveying', crew: 'inspector_land_surveying', inspectorRole: 'land_surveying' },
    {
      name: 'Living Area Measurement',
      crew: 'inspector_living_area_measurement',
      inspectorRole: 'living_area_measurement'
    },
    {
      name: 'Mold Remediation',
      crew: 'inspector_mold_remediation',
      inspectorRole: 'mold_remediation'
    },
    {
      name: 'Odor Remediation',
      crew: 'inspector_odor_remediation',
      inspectorRole: 'odor_remediation'
    },
    { name: 'Plumbing', crew: 'inspector_plumbing', inspectorRole: 'plumbing' },
    { name: 'Pool', crew: 'inspector_pool', inspectorRole: 'pool' },
    { name: 'Radon', crew: 'inspector_radon', inspectorRole: 'radon' },
    { name: 'Roof', crew: 'inspector_roof', inspectorRole: 'roof' },
    { name: 'Septic & Sewer', crew: 'inspector_septic', inspectorRole: 'septic' },
    { name: 'Structural', crew: 'inspector_structural', inspectorRole: 'structural' },
    { name: 'Termite', crew: 'inspector_termite', inspectorRole: 'termite' },
    { name: 'Valuation', crew: 'inspector_valuation', inspectorRole: 'valuator' },
    { name: 'Wells', crew: 'inspector_wells', inspectorRole: 'wells' },
  ]).name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/values/inspector-crews.js
 **/